"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Long = require("long");
var STANDARD_ROWKEY_LENGTH = 16;
var MAP_ROW_SIZE = 32;
var MAP_COLUMN_SIZE = 64;
var MAP_ROW_MAX_INDEX = 31;
var MAP_COLUMN_MAX_INDEX = 61;
function cidToRowkey(cid) {
    if (!cid)
        return null;
    if (!/^\d+$/.test(cid)) {
        return null;
    }
    var cidLong = Long.fromString(cid);
    if (!checkCID(cid)) {
        return null;
    }
    var srcAddrNum = cidLong.and((1 << 11) - 1).toNumber();
    cidLong = cidLong.shiftRightUnsigned(11);
    var randomNum = cidLong.and((1 << 10) - 1).toNumber();
    cidLong = cidLong.shiftRightUnsigned(10);
    var oneLong = new Long(1);
    oneLong = oneLong.shiftLeft(32);
    oneLong = oneLong.sub(1);
    var timestamp = cidLong.and(oneLong).toNumber();
    cidLong = cidLong.shiftRightUnsigned(32);
    var regionId = cidLong.toNumber();
    var srcAddr = mappingIndexToStr(srcAddrNum);
    var rowkey = "" + fixNum(3, regionId) + fixNum(8, timestamp.toString(16)) + fixNum(3, randomNum) + srcAddr;
    return rowkey;
}
exports.cidToRowkey = cidToRowkey;
function fixNum(num, target) {
    if (String(target).length < num) {
        return repeatStr('0', num - String(target).length) + target;
    }
    return target;
}
function repeatStr(str, times) {
    var target = '';
    for (var i = 0; i < times; i++) {
        target += str;
    }
    return target;
}
function mappingIndexToStr(srcAddrNum) {
    var rowIndex = srcAddrNum >> 6;
    var columnIndex = srcAddrNum & (MAP_COLUMN_SIZE - 1);
    if (rowIndex > MAP_ROW_MAX_INDEX || columnIndex > MAP_COLUMN_MAX_INDEX) {
        return null;
    }
    var firstSrc = getRowRune(rowIndex);
    var secondSrc = getColumnRune(columnIndex);
    var resultStr = firstSrc + secondSrc;
    return resultStr;
}
function getRowRune(index) {
    if (index <= 9) {
        return String.fromCharCode(index + 48);
    }
    else if (index <= 20) {
        return String.fromCharCode(index + 55);
    }
    else {
        return String.fromCharCode(index + 76);
    }
}
function getColumnRune(index) {
    if (index <= 9) {
        return String.fromCharCode(index + 48);
    }
    else if (index <= 35) {
        return String.fromCharCode(index + 55);
    }
    else {
        return String.fromCharCode(index + 61);
    }
}
function checkCID(cid) {
    var cidLong = Long.fromString(cid);
    // [53-63位]
    var srcAddrNum = cidLong.and((1 << 11) - 1).toNumber();
    cidLong = cidLong.shiftRightUnsigned(11);
    // [43-52位]
    var randomNum = cidLong.and((1 << 10) - 1).toNumber();
    cidLong = cidLong.shiftRightUnsigned(10);
    cidLong = cidLong.shiftRightUnsigned(32);
    var regionId = cidLong.toNumber();
    if (!(regionId >= 0 && regionId <= 999) || !(randomNum >= 0 && randomNum <= 999)) {
        return false;
    }
    var rowIndex = srcAddrNum >>> 6;
    var columnIndex = srcAddrNum & (MAP_COLUMN_SIZE - 1);
    if (rowIndex > MAP_ROW_MAX_INDEX || columnIndex > MAP_COLUMN_MAX_INDEX) {
        return false;
    }
    return true;
}
exports.checkCID = checkCID;
/**
 * rowkey转cid，如果失败，返回null
 * 和go版本不一样的是，go版本返回Uint64类型，js最大没有64，所以返回一个string
 * @param rowkey
 */
function rowkeyToCID(rowkey) {
    if (!checkRowkey(rowkey)) {
        return null;
    }
    var parsed = parseRowkey(rowkey);
    if (isNaN(parsed.timestamp)) {
        return null;
    }
    var mappingSrcAddrNum = mappingStrToIndex(parsed.firstSrc, parsed.secondSrc);
    var cid = new Long(0);
    cid = cid.or(parsed.regionId);
    cid = cid.shiftLeft(32);
    cid = cid.or(parsed.timestamp);
    cid = cid.shiftLeft(10);
    cid = cid.or(parsed.randomNum);
    cid = cid.shiftLeft(11);
    cid = cid.or(mappingSrcAddrNum);
    return cid.toString();
}
exports.rowkeyToCID = rowkeyToCID;
/**
 * 将src解析成12个bit大小的数字
 * @param first
 * @param second
 */
function mappingStrToIndex(first, second) {
    var rowIndex = getRowIndex(first);
    var columnIndex = getColumnIndex(second);
    var result = MAP_COLUMN_SIZE * rowIndex + columnIndex;
    return result;
}
/**
 * 获取src第一位的偏移量，0的偏移量就是0，9的偏移量是9，A的偏移量是10，K的偏移量是20，a的偏移量是21， k的偏移量是31
 * @param ch
 */
function getRowIndex(ch) {
    if (/[0-9]/.test(ch)) {
        return ch.charCodeAt(0) - 48;
    }
    else if (/[A-K]/.test(ch)) {
        return ch.charCodeAt(0) - 55;
    }
    else if (/[a-k]/.test(ch)) {
        return ch.charCodeAt(0) - 76;
    }
}
function getColumnIndex(ch) {
    if (/[0-9]/.test(ch)) {
        return ch.charCodeAt(0) - 48;
    }
    else if (/[A-Z]/.test(ch)) {
        return ch.charCodeAt(0) - 55;
    }
    else if (/[a-z]/.test(ch)) {
        return ch.charCodeAt(0) - 61;
    }
}
function parseRowkey(rowkey) {
    var firstSrc = rowkey[STANDARD_ROWKEY_LENGTH - 2];
    var secondSrc = rowkey[STANDARD_ROWKEY_LENGTH - 1];
    var regionId = +rowkey.substring(0, 3);
    var timestamp = parseInt(rowkey.substring(3, 11), 16);
    var randomNum = +rowkey.substring(11, 14);
    return {
        firstSrc: firstSrc,
        secondSrc: secondSrc,
        regionId: regionId,
        timestamp: timestamp,
        randomNum: randomNum,
    };
}
/**
 * 校验rowkey
 * @param rowkey
 */
function checkRowkey(rowkey) {
    if (!rowkey)
        return false;
    if (rowkey.length != STANDARD_ROWKEY_LENGTH) {
        return false;
    }
    var parsed = parseRowkey(rowkey);
    if (!srcAddrCheck(parsed.firstSrc, parsed.secondSrc)) {
        return false;
    }
    if (isNaN(parsed.regionId) || isNaN(parsed.randomNum)) {
        return false;
    }
    return true;
}
exports.checkRowkey = checkRowkey;
/**
 * 校验rowkey的最后两位(来源位)
 * @param first
 * @param second
 */
function srcAddrCheck(first, second) {
    if (!(/[0-9]/.test(first) || /[a-k]/i.test(first))) {
        return false;
    }
    if (!(/[0-9]/.test(second) || /[a-z]/i.test(second))) {
        return false;
    }
    return true;
}
